import { nanoid } from "@reduxjs/toolkit";
import { Nullable } from "src/shared/utils/utility-types";
import { ChatMessageDTOExtended } from "src/store/messenger";

const getDateString = (datetime?: Date | string) => {
  const fullDate = datetime ? new Date(datetime) : new Date();

  const date = fullDate.getDate();
  const month = fullDate.toLocaleString("default", {
    month: "long",
  });

  return `${month} ${date}`;
};

const getSeparator = (messageDateString: string, isUnread?: boolean) => {
  if (isUnread) return "Unread messages";

  const todayDateString = getDateString();
  const isTodayMessage = todayDateString === messageDateString;

  return isTodayMessage ? "Today" : messageDateString;
};

type MessageByDate = {
  id: string;
  separatorText: string;
  messageIds: string[];
};

export const groupMessagesByDate = (
  messageList?: ChatMessageDTOExtended[],
): MessageByDate[] => {
  if (!messageList || !Array.isArray(messageList)) return [];

  let savedDateString: Nullable<string> = null;

  return messageList.reduce<MessageByDate[]>((acc, currentMessage) => {
    const messageDateString = getDateString(currentMessage.datetime);

    if (messageDateString !== savedDateString) {
      savedDateString = messageDateString;
      const newChain = {
        id: nanoid(),
        separatorText: getSeparator(messageDateString, currentMessage.isUnread),
        messageIds: [currentMessage.id],
      };

      return [...acc, newChain];
    }

    const lastChainIndex = acc.length - 1;
    const lastChain = acc[lastChainIndex];
    lastChain.messageIds.push(currentMessage.id);

    return acc;
  }, []);
};
